import { setContext } from '@apollo/client/link/context';

export default setContext(() => {
  const authToken = localStorage.getItem('authToken');
  const headers = authToken ? { authorization: authToken } : {};
  return { headers };
});
